//angular imports
import {
    Component, 
    InputSignal, 
    WritableSignal,         
    signal,
    input,
    computed,
    ViewChild,
    ElementRef,
    ChangeDetectionStrategy,
} from '@angular/core';

//local imports
import { DropDownAnimation, FadeIn } from './animation';
import { Transforms } from '@app/shared/helpers/transforms';

@Component({
    selector: 'tree-item',
    templateUrl: './tree-item.component.html',
    styleUrl: './tree-item.component.scss',
    animations: [FadeIn(500, false), DropDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TreeItemComponent
{  
    private _internalIsOpen = signal<boolean>(false);    
        
    @ViewChild('childGroup') 
    public childGroup: ElementRef;  
            
    public showExpander= input(true, {
        transform: Transforms.toBoolean
    });

    public isOpen: InputSignal<WritableSignal<boolean>> = input<WritableSignal<boolean>>();   
    public hasChildren: InputSignal<boolean> = input.required();

    public openState = computed(() => 
    {        
        if (!this.hasChildren()) return false;

        let isOpenSignal = this.isOpen();

        if (isOpenSignal === undefined) return this._internalIsOpen();
        
        let isOpen = isOpenSignal();    
        
        return isOpen;
    });
    
    
    public toggleOpen()
    {
        if (!this.hasChildren())  return;
                        
        let isOpenSignal = this.isOpen();
        if (isOpenSignal === undefined)
        {
            this._internalIsOpen.set(!this._internalIsOpen());
            return;
        }

        isOpenSignal.set(!isOpenSignal());
    }
}
